module.exports = {
    tag: 'sindri',
    quality: 1.0,
    magicalGravity: 0.5, 
    mana: 4,
    willpower: 3,
    perception: 3,
};